<template>
  <div ref="chart">
    <Chart :extendData="extendData" :height="height" :id="id"
           :option="option" :width="width"></Chart>
  </div>
</template>

<script>
import Chart from '@/components/echarts/Chart';

export default {
  name: "GaugeChart1",
  components: {Chart},
  props: {
    data: null,
    extendData: null,
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 300
    },
    datas:{},
  },
  data() {
    return {
      id: "gaugeChart",
      width: '100%',
      height: '100%',
      option: {},
    };
  },
  watch: {
    data() {
      this.getOption();
    }
  },
  mounted() {
    console.log((this.max ? this.max : 300), this.min);
    this.getOption();
  },
  methods: {
    getOption: function () {
      var colorSet = {
        color: 'rgba(41,159,251,0.4)'
      };
      this.option = {
        tooltip: {
          show: false,
          formatter: "{a} <br/>{b} : {c}%"
        },

        series: [{
          name: "",
          type: "gauge",
          // center: ['20%', '50%'],
          min: (this.min ? this.min : 0), //最小刻度
          max: (this.max ? this.max : 300), //最大刻度
          radius: '100%',
          splitNumber: 10,
          axisLine: {
            lineStyle: {
              color: [
                [this.data / (this.max ? this.max : 300), 'rgba(41,159,251,0.8)'],
                [1, colorSet.color]
              ],
              width: 6
            }
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,

          },
          splitLine: {
            show: false,
          },
          itemStyle: {
            show: false,
          },
          detail: {
            show: false,
          },
          title: { //标题
            show: false,
          },
          data: [{
            name: "title",
            value: this.data,
          }],
          pointer: {
            show: true,
            length: '75%',
            radius: '20%',
            width: 2, //指针粗细
          },
          animationDuration: 4000,
        },
          {
            name: '内部刻度',
            type: 'gauge',
            //  center: ['20%', '50%'],
            radius: '75%',
            min: (this.min ? this.min : 0), //最小刻度
            max: (this.max ? this.max : 300), //最大刻度
            splitNumber: 4, //刻度数量
            startAngle: 225,
            endAngle: -45,
            axisLine: {
              show: true,
              lineStyle: {
                width: 11,
                color: [
                  [1, 'rgba(0,0,0,0)']
                ]
              }
            }, //仪表盘轴线
            axisLabel: {
              show: true,
              color: '#fff',
              fontSize: 8,
              distance: 7,
            }, //刻度标签。
            axisTick: {
              show: true,
              splitNumber: 10,
              lineStyle: {
                color: colorSet.color, //用颜色渐变函数不起作用
                width: 2,
              },
              length: -3
            }, //刻度样式
            splitLine: {
              show: false,
              length: -5,
              lineStyle: {
                color: colorSet.color, //用颜色渐变函数不起作用
              }
            }, //分隔线样式
            detail: {
              show: false
            },
            pointer: {
              show: false
            }
          },
        ]
      };
    },
  },
}
</script>

<style scoped>

</style>
